import { SimpleHandler, SimpleAVHandler } from 'src/app/types/@types/sl-v-types';
import { Directive, ElementRef, HostListener, Input } from '@angular/core';

export type NodragHandler = SimpleAVHandler<'blur'|'focus'>

@Directive({
  selector: '[appNoDrag]'
})
export class NodragDirective {
  _editing = false;
  @Input()
  noDragHandler:NodragHandler;
  @HostListener('mousedown') onMouseDown() {
    if(!this.noDragHandler)  return;
    this._editing = true;
    this.noDragHandler('focus');
  }

  @HostListener('blur') onBlur() {
    if(!this.noDragHandler)  return;
    this._editing = false;
    this.noDragHandler('blur');
  }

  constructor() {
  }

}
